import { onDocumentReady } from "#/admin/legacy/forms/document-ready.js";
import { initializePolymorphicSelects, updateClassSelection } from "#/admin/legacy/forms/polymorphic-select.js";

// Toggle the polymorphic option group when the selected class changes
document.addEventListener("change", updateClassSelection);

// INITIALIZE
onDocumentReady(initializePolymorphicSelects);
